import './App.css';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Mission from './components/Mission';
import Story from './components/Story';
import Programs from './components/Programs';
import Impact from './components/Impact';
import GetInvolved from './components/GetInvolved';
import Donate from './components/Donate';
import Contact from './components/Contact';
import Footer from './components/Footer';
import BackToTop from './components/BackToTop';

function App() {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY || ''}
      scriptProps={{
        async: true,
        defer: true,
        appendTo: 'head',
      }}
    >
      <Navbar />
      <Hero />
      <Mission />
      <Story />
      <Programs />
      <Impact />
      <GetInvolved />
      <Donate />
      <Contact />
      <Footer />
      <BackToTop />
    </GoogleReCaptchaProvider>
  );
}

export default App;
